import * as React from "react";
import { Checkbox, notification } from "antdv5";
import type { SetState, Fn, ITableFilters } from "../../../client_types";

interface IPageInfo {
  pageSize: number | null | undefined;
  current: number | null | undefined;
}
interface IProps {
  endDate: Date | null;
  isChecked: boolean;
  searchData: Fn;
  pageInfo: IPageInfo;
  preventRefreshCount: (fn: Fn, count: number) => void;
  handleAuth: Fn;
  setFindName: SetState<ITableFilters>;
  setPageInfo: SetState<IPageInfo>;
  setRank: SetState<"ASC" | "DES">;
  setSortText: SetState<"正序" | "倒序">;
  setDateRange: SetState<[Date | null, Date | null]>;
  setData: SetState<{ data: any[]; count: number | null }>;
  setStorageIsCheck: SetState<boolean | null>;
  setStorageTime: SetState<[string | null, string | null]>;
  setStorageSearchValue: SetState<{
    feetNo: string;
    matchNumber: string;
    memberName: string;
  }>;
  setLock: SetState<boolean>;
  setIsChecked: SetState<boolean>;
  fetchNewData: (pageSize: number, current: number) => void;
}
const ButtonGroup = ({
  endDate,
  isChecked,
  searchData,
  pageInfo,
  preventRefreshCount,
  handleAuth,
  setFindName,
  setPageInfo,
  setRank,
  setSortText,
  setDateRange,
  setData,
  setStorageIsCheck,
  setStorageTime,
  setStorageSearchValue,
  setLock,
  setIsChecked,
  fetchNewData,
}: IProps) => {
  const [api, ctx] = notification.useNotification();
  return (
    <>
      {ctx}
      <div className="btnGroup">
        <Checkbox checked={isChecked} onChange={() => setIsChecked(!isChecked)}>
          排除重复
        </Checkbox>
        <button
          onClick={() => {
            if (endDate === null) {
              api.error({
                message: "注意!",
                description: "请选择起始日期及结束日期",
                placement: "top",
              });
            } else {
              preventRefreshCount(searchData, 3);
              handleAuth();
            }
            setPageInfo({
              ...pageInfo,
              current: 1,
            });
          }}
          // disabled={lock}
        >
          搜寻
        </button>
        <button
          onClick={() => {
            handleAuth();
            setFindName({
              searchFeetNo: "",
              searchName: "",
              memberName: "",
            });
            setPageInfo({
              ...pageInfo,
              current: 1,
            });
            setRank("ASC");
            setSortText("正序");
            setDateRange([null, null]);
            setData({ data: [], count: null });
            setStorageIsCheck(null);
            setStorageTime([null, null]);
            setStorageSearchValue({
              feetNo: "",
              matchNumber: "",
              memberName: "",
            });
            setLock(true);
          }}
          // disabled={lock}
        >
          重置
        </button>
      </div>
    </>
  );
};

export default ButtonGroup;
